export interface PaginationParameters {
  PageNumber: number;
  PageSize: number;
}

export interface PaginationResponse {
  currentPage: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

export const InitialPaginationParameters: PaginationParameters = {
  PageNumber: 1,
  PageSize: 10,
};

export const InitialPaginationResponse: PaginationResponse = {
  currentPage: InitialPaginationParameters.PageNumber,
  hasPreviousPage: false,
  hasNextPage: false,
  pageSize: InitialPaginationParameters.PageSize,
  totalCount: 0,
  totalPages: 0,
};

/* TODO Replace any/ CORE-1006 */
/* eslint-disable  @typescript-eslint/no-explicit-any */
export const PopulatePagination = (Payload: any) => {
  const result = Payload.result || Payload;
  const PaginationData: PaginationResponse = {
    currentPage: result.currentPage,
    hasPreviousPage: result.hasPreviousPage,
    hasNextPage: result.hasNextPage,
    pageSize: result.pageSize,
    totalCount: result.totalCount,
    totalPages: result.totalPages,
  };
  return PaginationData;
};
